import { Component, OnInit } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-manual-send-mail-message-dialog',
  templateUrl: './manual-send-mail-message-dialog.component.html',
  styleUrls: ['./manual-send-mail-message-dialog.component.css'],
  standalone: false,
})
export class ManualSendMailMessageDialogComponent implements OnInit {

  readonly manualTopLink: string = AppConst.ROUTING_LINK_MANUAL_INDEX;
  readonly projectDialogLink: string = AppConst.ROUTING_MANUAL_PROJECT_DIALOG;

  currentLang: string = 'ja';

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLang = this.translate.currentLang;
  }

}
